module.exports = __webpack_public_path__ + "static/media/153.e50a836c.jpg";